import useCredentialOffers from '@hooks/queries/credential/offer/useCredentialOffers';
import { useParties } from '../../contexts/PartiesContext';

export const useInboundCredentialOffers = () => {
  const offers = useCredentialOffers();
  const { party } = useParties();
  const filtered = offers.data?.filter((offer) => offer.payload.holder === party);
  return filtered || [];
};
